<template>
	<!--团队-->
	<div class="box">
		<div class="joinedComposition" v-if="alxqBool==false">
			<div class="header">
				<div class="fl">
					<span>分享社区管理</span>
				</div>
				<div v-show="mzglBool">
					<div>
						
					</div>
				</div>
			</div>
			<div class="content_user">
				<div class="fl">
					<div class="navMenuTd" :class="mokuai==1?'active':''" @click="tabClick('1',$event)">
						<span>报告审核及发布</span>
						<i class=""></i>
					</div>
					<div class="navMenuTd" :class="mokuai==2?'active':''" @click="tabClick('2',$event)">
						<span>分享报告管理</span>
						<i class=""></i>
					</div>
				</div>
				<div>
					<div v-if="mokuai==1" class="tableBox">
						<div class="">
							<ul class="tableHeader">
								<li v-for="item in tableList">{{item.tableName}}</li>
							</ul>
							<div class="tablecontentBox">
								<ul class="tablecontent tableHeader">
									<li> 拔牙患者种植支抗的研究</li>
									<li>王冬</li>
									<li>贾培增</li>
									<li>普通</li>
									<li>免费</li>
									<li>
										<div>
											<button>审核编辑</button>
										</div>
									</li>
									<li>
										<div>
											<button>发布</button>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div v-if="mokuai==2" >
						<div class="numDoctor_box">
							<div class="numDoctor">
								<div>
									<el-input
									    placeholder="输入申请人或专家姓名"
									    prefix-icon="el-icon-search"
									    v-model="input2">
									  </el-input>
								</div>
								<div class="btn">
									<button @click="doctors_artcles_tjFn">搜索</button>
								</div>
							</div>
							<div class="chartsDoc1">
								<ul class="tableHeaders tableHeaderbox">
									<li v-for="item in tableLists">{{item.tableName}}</li>
								</ul>
								<!--  -->
								<div class="tabletd">
									<ul class="tablecontents tableHeaders">
										<li>拔牙患者种植支抗的研究</li>
										<li>王冬</li>
										<li>贾培增</li>
										<li>免费</li>
										<li>113</li>
										<li>
											<div class="">
												<button>编辑报告</button>
											</div>
											<div class="" @click="doctors_artcles_setfreeFn(item.id,1)">
												<button style="background:#F56C6C">撤销分享</button>
											</div>
										</li>
										<li>
											<div class="">
												<button @click="alxqBool=true">查看详情</button>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
		<div class="myJoined" v-if="alxqBool==true">
			<div class="headers">
				<div class="fl">
					<i class="" style="cursor: pointer;" @click="alxqBool=false"></i>
					<span></span>
					<span>分享案例详情</span>
				</div>
				<div v-show="mzglBool">
					<div>
						
					</div>
				</div>
			</div>
			<div class="doctorzjtd">
				<div class="jbxx">
					<p>基本信息</p>
					<p>
						<span>分享标题</span>
						<span>拔牙患者种植支抗的研究</span>
					</p>
					<p>
						<span>申请人</span>
						<span>王东</span>
					</p>
					<p>
						<span>申请专家</span>
						<span>贾配赠</span>
					</p>
					<p>
						<span>实审专家</span>
						<span>贾配赠</span>
					</p>
					<p>
						<span>申请时间</span>
						<span>2020.06.15 20:20</span>
					</p>
					<p>
						<span>完成时间</span>
						<span>2020.06.15 20:20</span>
					</p>
					<p>
						<span>审阅耗时</span>
						<span>15小时</span>
					</p>
				</div>
				<div class="jbxx">
					<p>价格</p>
					<p>
						<span>初审定价</span>
						<span>300</span>
					</p>
					<p>
						<span>优惠价格</span>
						<span  style="display: flex; align-items: center;" v-if="xgBool==false">
							244
							<div class="btns" @click="xgBool=true">
								<button>修改价格</button>
							</div>
						</span>
						<span style="display: flex; align-items: center;"  v-if="xgBool==true">
							<div class="inputediv">
								<el-input v-model="num" placeholder="请输入内容"></el-input>
							</div>
							<div class="btns" @click="xgBool=false">
								<button>确认修改</button>
							</div>
						</span>
					</p>
				</div>
				<div class="jbxx">
					<p>围观</p>
					<p>
						<span>分享评级</span>
						<span>普通</span>
					</p>
					<p>
						<span>围观定价</span>
						<span  style="display: flex; align-items: center;" v-if="wgxgBool==false">
							3
							<div class="btns" @click="wgxgBool=true">
								<button>修改价格</button>
							</div>
						</span>
						<span style="display: flex; align-items: center;"  v-if="wgxgBool==true">
							<div class="inputediv">
								<el-input v-model="num" placeholder="请输入内容"></el-input>
							</div>
							<div class="btns" @click="wgxgBool=false">
								<button>确认修改</button>
							</div>
						</span>
					</p>
					<p>
						<span>围观次数</span>
						<span>113</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState,mapMutations} from 'vuex'

	export default{
		components:{
		},
		data(){
			return{
				companysrow:{},
				csVal:'',
				glList:[],
				drList:[],
				atList:[],
				addCyBool:false,
				tdlist:[],
				tel:'',
				xxgsVal:false,
				sqVal:true,
				nameVal:'',
				zspwdVal:'',
				addressVal:'',
				lxtel:'',
				gfwzVal:'',
				vxVal:'',
				ylImg:'',
				yyImg:'',
				sList:[],
				sheng:'',
				shiList:[],
				shi:'',
				xianList:[],
				xian:'',
				glyName:'',
				usersetBool:false,
				mrImg:'http://api.bats-bio.com/upload/2019-10-23/5dafbb3a5a2f6.png',
				yyxkImg:false,
				yyzzImg:false,
				mzglBool:false,
				cyglBool:false,
				szczBool:false,
				minname:'',
				xiugaiqueding:false,
		    	deleUser:[],
		    	lxdhval:'',
		    	centerDialogVisible:false,
				DialogImg:'',
				thiscpyId:this.cpyId,
				setglyBool:false,
				uNameGly:'',
				uIdGly:'',
				sqList:[],
				xxgsRz:'',
				lxdhvalqh:'',
				lxdhvalhm:'',
				cIsRZ:'',
				dialoggrzyBool:false,
				wsdaqBool:false,
				tiuchuzhensuoBool:false,
				mokuai:1,
				tableList:[{
						tableName:'分享标题 ',
					},{
						tableName:'申请人',
					},{
						tableName:'审阅专家',
					},{
						tableName:'推荐级别',
					},{
						tableName:'围观定价',
					},{
						tableName:'审核操作',
					},{
						tableName:'发布操作',
					}
				],
				tableLists:[{
						tableName:'分享标题 ',
					},{
						tableName:'申请人',
					},{
						tableName:'审阅专家',
					},{
						tableName:'围观定价',
					},{
						tableName:'围观次数',
					},{
						tableName:'分享操作',
					},{
						tableName:'其他操作',
					}
				],
				num:244,
				xgBool:false,
				wgxgBool:false,
				alxqBool:false
			}
		},
		created(){
//			this.chengshiFn();
		},
		mounted(){
//			this.companys_rowFn();
		},
		methods:{
			 move(e){
	            let odiv = e.target;  
	            let disX = e.clientX - odiv.offsetLeft;
	            let disY = e.clientY - odiv.offsetTop;
	            document.onmousemove = (e)=>{    
	                let left = e.clientX - disX;    
	                let top = e.clientY - disY;
                	odiv.style.left = left + 'px';
                	odiv.style.top = top + 'px';
	            };
	            document.onmouseup = (e) => {
	                document.onmousemove = null;
	                document.onmouseup = null;
	            };
		    },
			
			
			
			fhFn(bol){
				this.$emit('getMessage', bol)
			},
			imgCloseFn(){
				this.yyzzImg=false;
				this.yyxkImg=false;
			},
			
			up(a,b){
				return a.uTypeID-b.uTypeID
			},
			deleteFn(id){
				var data={
					cpy_id:this.companysrow.id,
					uid:id
				}
				users_delete_from_company(data).then(res=>{
//					console.log(res.data)
				})
			},
			setglyFn(){
				var data={
					uid:this.uIdGly,
					cpy_id:this.companysrow.id,
					zt:1
				}
				set_dual_status(data).then(res=>{
					this.$message({
			            type: 'success',
			            message: '设置成功',
						duration: 1000,
			            onClose: () => {
							this.setglyBool=false;
							this.glListFn();
						}
			        });
				})
			},
			remoreArr(id,event,typeid){
				for(var i=0;i<this.deleUser.length;i++){
					if(this.deleUser[i]==id){
						this.deleUser.splice(1,1);
						var el = event.currentTarget; 
						$(el).hide();
						$(el).siblings('.el-icon-delete-solid').show();
					}
				}
			},
		    tabClick(str,el){
				var el = event.currentTarget; 
				$(el).addClass('active').siblings().removeClass('active')
				this.mokuai=str;
			},
		},
		computed: {
			...mapState(['is_two','login_id'])
		},
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height:836px;
	}
	.notJoined{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.notJoined>div{
		width:299px;
		height:274px;
		padding:0 40px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 12px 0px rgba(0,0,0,0.13);
		border-radius:8px;
		margin-top: -100px;
	}
	.notJoined>div>div:nth-child(2){
		font-size:14px;
		font-family:PingFangSC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
		margin-bottom: 60px;
		margin-top: 90px;
	}
	.notJoined>div:nth-child(1)>div:nth-child(3)>button{
		width:299px;
		height:35px;
		background:rgba(176,176,176,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:16px;
	}
	.notJoined>div:nth-child(2)>div:nth-child(3)>button{
		width:299px;
		height:35px;
		background:rgba(0,120,255,1);
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		font-size:11px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:16px;
	}
	.myJoined,.joinedComposition{
		width: 100%;
		height:836px;
		background:rgba(255,255,255,1);
		box-shadow:2px 2px 2px 0px rgba(119,151,178,0.16);
	}
	.header,.headers{
		width:100%;
		height:72px;
		background:rgba(255,255,255,1);
		box-shadow:0px 2px 2px 0px rgba(119,151,178,0.16);
		z-index: 90;
		position: relative;
		overflow: hidden;
	}
	.header>div:nth-child(1),.headers>div:nth-child(1){
		width:255px;
		height: 100%;
		float: left;	
		position: absolute;
		display: flex;
		align-items: center;
	}
	.headers>div:nth-child(1)>i{
		margin-left: 23px;
		margin-right: 12px;
		display: block;
		width:7px;
		height:13px;
		background:url(../../../assets/image/left.png) no-repeat center center;
		background-size:100% ;
	}
	.headers>div:nth-child(1)>i:hover{
		margin-left: 21px;
		margin-right: 12px;
		display: block;
		cursor: pointer;
		width:9px;
		height:15px;
		background:url(../../../assets/image/left.png) no-repeat center center;
		background-size:100% ;
	}
	.headers>div:nth-child(1)>span:nth-child(2){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(155,155,155,1);
		line-height:68px;
	}
	.headers>div:nth-child(1)>span:nth-child(3){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(74, 74, 74, 1);
		line-height:68px;
		margin-left: 14px;
		
	}
	.header>div:nth-child(1)>span:nth-child(1){
		font-size:18px;
		font-family:PingFangSC;
		color:rgba(74, 74, 74, 1);
		line-height:68px;
		margin-left: 14px;
		
	}
	.header>div:nth-child(2){
		margin-left: 130px;
		height: 100%;
	}
	.header>div:nth-child(2)>div:nth-child(1){
		width: 100%;
	}
	.content_user,.doctorzjtd{
		width:100%;
		height:760px;
		background:RGBA(235, 235, 235, 1);
		overflow: hidden;
	}
	.doctorzjtd{
		display: flex;
		
	}
	.doctorzjtd>div{
		margin-right: 100px;
	}
	.joinedList>div{
		width:216px;
		height:118px;
		background:rgba(255,255,255,.7);
		border-radius:3px;
		font-size:14px;
		font-family:PingFangSC;
		font-weight:500;
		color:rgba(74,74,74,1);
		text-align: center;
		line-height: 118px;
		margin: 10px 0;
	}
	.content_user>div.fl{
		width:206px;
		height:760px;
		background:#F6F6F6;
		box-shadow:2px 0px 4px 0px rgba(155,155,155,0.23);
		position: absolute;
		z-index: 999;
	}
	.content_user>div:nth-child(2){
		margin-left: 206px;	
		height: 100%;	
	}
	.content_user>div:nth-child(2)>div{
		/*padding: 10px;*/
	}
	.navMenuTd:nth-child(1){
		z-index: 999;
		padding-top:0px;
		margin-top: 0px;
	}
	.navMenuTd:nth-child(2){
		z-index: 998;
	}.navMenuTd:nth-child(3){
		z-index: 997;
		
	}
	.navMenuTd{
		width:206px;
		height:50px;
		padding-top:10px;
		margin-top: -10px;
		background:rgba(246,246,246,1);
		box-shadow:0px 2px 4px 0px rgba(155,155,155,0.4);
		border-radius:0px 0px 15px 0px;
		cursor: pointer;
		line-height:50px;
		position: relative;
		margin-bottom: 5px;
	}
	.navMenuTd>span{
		font-size:14px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		margin-left: 15px;
	}
	.navMenuTd:nth-child(1)>i{
		top: 19px;
	}
	.navMenuTd>i{
		display: block;
		width:7px;
		height:13px;
		background: url(../../../assets/image/navMenuTd.png) no-repeat center center;
		background-size:100% ;
		position: absolute;
		right: 40px;
		top: 29px;
		/*transition: .3s all;*/
	}
	.navMenuTd:hover{
		background: #FFFFFF;
	}
	.navMenuTd:hover span{
		color:#3B97FF ;		
		
	}
	.navMenuTd:hover i{
		background: url(../../../assets/image/navMenuTdActive.png) no-repeat center center;
		background-size:100% ;
	}
	.navMenuTd.active{
		background: #FFFFFF;
		
	}
	.navMenuTd.active>span{
			color:#3B97FF ;		
	}
	.navMenuTd.active>i{
		background: url(../../../assets/image/navMenuTdActive.png) no-repeat center center;
		background-size:100% ;
	    transform: rotate(90deg);
	    transition: .3s all;
	}
	i.active{
		display: block;
		width:14px;
		height:14px;
		float: left;
		border-radius: 50%;
		margin-right: 3px;
		background: rgba(0, 120, 255, 1);
	}
	.tdBox_div{
		width: 220px;
		height: 160px;
		background: #FFFFFF;
		overflow: hidden;
		margin-right: 10px;
		margin-bottom: 10px;
		border-radius: 5px;
	}
	.tdBox_div>p{
		margin-top: 45px;
		font-size:20px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		text-align: center;
		margin-bottom:10px;
	}
	.tdBox{
		display: flex;
		flex-wrap: wrap;
	}
	.tdBox_div>div {
		width: 100px;
		height: 30px;
		margin: 0 auto;

	}
	.tdBox_div>div:hover button {
		border: 2px solid yellow;
	}
	
	.tdBox_div>div>button {
		float: left;
		width: 100px;
		height: 30px;
		background: rgba(0, 120, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(121, 139, 149, 0.44);
		border-radius: 3px;
		font-size: 11px;
		font-family: PingFangSC-Medium, PingFangSC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
	}
	.tableHeader{
		width: 100%;
		height: 20px;
		/*border-bottom: 1px solid #CCCCCC;*/
		background:#FFFFFF ;
	}
	.tableHeader li ,.tablecontent li{
		float: left;
		text-align: center;
		font-size: 12px;
		line-height: 20px;
		color: #9B9B9B;
	}
	.tableHeader li:nth-child(1){
		width: 30%;
	}
	.tableHeader li:nth-child(2){
		width: 10%;
	}
	.tableHeader li:nth-child(3){
		width: 10%;
	}
	.tableHeader li:nth-child(4){
		width:  10%;
	}
	.tableHeader li:nth-child(5){
		width:10%;
	}
	.tableHeader li:nth-child(6){
		width: 15%;
	}
	.tableHeader li:nth-child(7){
		width: 15%;
	}
	.tableBox{
		/*padding: 10px;*/
		height: 100%;
		width: 100%;
	}
	.tableBox>div{
		width: 100%;
		border: 1px solid #FFFFFF;
		
	}
	.tablecontent{
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #FDFBE5;
		
	}
	.tablecontent li{
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		/*z-index: 2;*/
		/*overflow: hidden;*/
	}
	.tablecontent li:nth-child(1)::before{
		display: none;
	}
	.tablecontent li::before{
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;/*px*/
	}
	.tablecontent li:nth-child(1){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontent li:nth-child(1)>p{
		margin: 0 10px;
		word-wrap:break-word;
   		 word-break: break-all 
	}
	.tablecontent li:nth-child(2){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontent li:nth-child(3){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontent li:nth-child(6),.tablecontent li:nth-child(7){
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tablecontent li:nth-child(7)>div,.tablecontent li:nth-child(6)>div{
		width:80px;
		height:30px;
		margin-right:10px ;
	}
	.tablecontent li:nth-child(7)>div:hover button,.tablecontent li:nth-child(6)>div:hover button{
		border: 2px solid yellow;
	}
	.tablecontent li:nth-child(7) button:nth-child(1),.tablecontent li:nth-child(6) button:nth-child(1){
		float: left;
		width:80px;
		height:30px;
		background:#0078FF;
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		color: #FFFFFF;
		border: none;
		font-size: 11px;
		cursor: pointer;
	} 
	.tablecontentBox{
		height: 600px;
	}
	.numDoctor{
		width: 212px;
		height: 720px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.btn{
		margin-top: 20px;
	}
	.btn:hover button{
		border: 1px solid yellow;
	}
	.btn>button{
		width: 100%;
		height: 40px;
        background: rgba(0, 120, 255, 1);
	    color: #FFFFFF;
	    font-size: 16px;
	    border-radius: 3px;
	}
	.btns{
		margin-left: 20px;
	}
	.btns:hover button{
		border: 1px solid yellow;
	}
	.btns>button{
		width: 100%;
		height: 40px;
        background: rgba(0, 120, 255, 1);
        border: 1px solid transparent;
	    color: #FFFFFF;
	    font-size: 16px;
	    border-radius: 3px;
	}
	.chartsDoc1{
		width:1075px;
		height:720px;
		padding: 10px 0px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		position: relative;
	}
	.numDoctor_box{
		padding: 10px;
		
		display: flex;
		justify-content:space-between ;
	}
	.tableHeaders{
		width: 100%;
		height: 20px;
		/*border-bottom: 1px solid #CCCCCC;*/
		background:#FFFFFF ;
	}
	.tableHeaders li ,.tablecontents li{
		float: left;
		text-align: center;
		font-size: 12px;
		line-height: 20px;
		color: #9B9B9B;
	}
	.tableHeaders li:nth-child(1){
		width: 30%;
	}
	.tableHeaders li:nth-child(2){
		width: 10%;
	}
	.tableHeaders li:nth-child(3){
		width: 10%;
	}
	.tableHeaders li:nth-child(4){
		width:  10%;
	}
	.tableHeaders li:nth-child(5){
		width:10%;
	}
	.tableHeaders li:nth-child(6){
		width: 15%;
	}
	.tableHeaders li:nth-child(7){
		width: 15%;
	}
	.tablecontents{
		width: 100%;
		height: 140px;
		border-bottom: 3px solid #FFFFFF;
		position: relative;
		background: #FDFBE5;
		
	}
	.tablecontents li{
		height: 140px;
		line-height: 140px;
		position: relative;
		color: #9B9B9B;
		/*z-index: 2;*/
		/*overflow: hidden;*/
	}
	.tablecontents li:nth-child(1)::before{
		display: none;
	}
	.tablecontents li::before{
		content: "";
		display: block;
		position: absolute;
		top: 11px;
		left: 0;
		width: 2px;
		height: 118px;
		border-left: 2px dashed #D7D9DC;/*px*/
	}
	.tablecontents li:nth-child(1){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontents li:nth-child(1)>p{
		margin: 0 10px;
		word-wrap:break-word;
   		 word-break: break-all 
	}
	.tablecontents li:nth-child(2){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	.tablecontents li:nth-child(3){
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 20px;
	}
	
	.tablecontents li:nth-child(7){
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tablecontents li:nth-child(7)>div,.tablecontents li:nth-child(6)>div{
		width:80px;
		height:30px;
		margin: 0 auto;
		
	}
	.tablecontents li:nth-child(6)>div{
		margin-top: 25px;

	}
	.tablecontents li:nth-child(7)>div:hover button,.tablecontents li:nth-child(6)>div:hover button{
		border: 2px solid yellow;
	}
	.tablecontents li:nth-child(7) button:nth-child(1),.tablecontents li:nth-child(6) button:nth-child(1){
		float: left;
		width:80px;
		height:30px;
		background:#0078FF;
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		color: #FFFFFF;
		border: none;
		font-size: 11px;
		cursor: pointer;
	} 
	.tablecontents li:nth-child(6) button:nth-child(2){
		width:80px;
		height:30px;
		background:#F56C6C;
		box-shadow:0px 1px 4px 0px rgba(121,139,149,0.44);
		border-radius:3px;
		color: #FFFFFF;
		border: none;
		font-size: 11px;
		cursor: pointer;
	} 
	.jbxx{
		margin: 20px;
		min-width: 200px;
	}
	.jbxx>p:nth-child(1){
		font-size:20px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:600 !important;
		color:rgba(74,74,74,1);
		margin-bottom: 20px;
		
	}
	.jbxx>p{
		font-size:16px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:400 !important;
		color:rgba(74,74,74,1);
		margin-bottom: 10px;
		display: flex;
		align-items: center;
	}
	.jbxx>p>span:nth-child(1){
		display: block;
		width: 100px;
		font-size:17px;
	}
	.inputediv{
		width: 100px;
	}
</style>

<style type="text/css">
	.comClass2 .el-upload{
		width:177px;
		height:130px;
	}
	.el-dialog--center .el-dialog__body{
		text-align: center;
	}
</style>
<!---->



// WEBPACK FOOTER //
// src/components/MA/operationManagement/sharingCommunity.vue